module.exports = __webpack_public_path__ + "img/feature-5.8fb24f5c.png";